import React from 'react';
import Header from '../components/Header';

function AdminPage() {
  return (
    <div style={{ maxWidth: '960px', margin: '40px auto', padding: '20px', fontFamily: 'sans-serif' }}>
      <Header role="admin" />
      <h1 style={{ fontSize: '1.8rem', marginBottom: '30px' }}>🛠 관리자 페이지</h1>

      {/* 사용자 현황 */}
      <section style={cardStyle}>
        <h2 style={sectionTitle}>📚 사용자 현황</h2>
        <ul style={listStyle}>
          <li>총 승인된 사용자: <strong>6명</strong></li>
          <li>학생 수: <strong>3명</strong></li>
          <li>강사 수: <strong>1명</strong></li>
        </ul>
      </section>

      {/* 승인 대기 사용자 */}
      <section style={cardStyle}>
        <h2 style={sectionTitle}>⏳ 승인 대기 사용자</h2>
        <p style={{ color: '#777' }}>승인 대기 중인 사용자가 없습니다.</p>
      </section>

      {/* 공지사항 등록 */}
      <section style={cardStyle}>
        <h2 style={sectionTitle}>📢 공지사항 등록</h2>
        <input type="text" placeholder="제목" style={inputStyle} />
        <textarea placeholder="내용" style={{ ...inputStyle, height: '100px' }} />
        <button style={buttonStyle}>공지 등록</button>
      </section>
    </div>
  );
}

const cardStyle = {
  backgroundColor: '#f9f9f9',
  border: '1px solid #ddd',
  borderRadius: '10px',
  padding: '20px',
  marginBottom: '30px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
};

const sectionTitle = {
  fontSize: '1.2rem',
  marginBottom: '16px',
  borderBottom: '2px solid #ccc',
  paddingBottom: '6px'
};

const listStyle = {
  lineHeight: '1.8',
  paddingLeft: '20px'
};

const inputStyle = {
  width: '100%',
  padding: '12px',
  borderRadius: '8px',
  border: '1px solid #ccc',
  marginBottom: '16px',
  fontSize: '1rem'
};

const buttonStyle = {
  padding: '12px 20px',
  backgroundColor: '#00704A',
  color: 'white',
  border: 'none',
  borderRadius: '8px',
  fontWeight: 'bold',
  cursor: 'pointer'
};

export default AdminPage;